import React, { useEffect, useState } from "react"
import { Box, IconButton, Divider, Collapse, CircularProgress } from "@material-ui/core"
import { Done as DoneIcon, Edit as EditIcon } from "@material-ui/icons"
import { Icon, Uploader, UploadingImagesList, RowBox } from ".."
import { TASK_RESPONSE_TYPE } from "../../data"
import { preventDefault, toId } from "../../utils"
import { useOffline } from "../Offline/useOffline"

const { PHOTOS } = TASK_RESPONSE_TYPE

const debounceRemoveMs = 1500
let debounceRemove

const AddPhotoStep = ({ expand, complete, responseUploads, classes, onChange, onRemove, onEdit, disabled }) => {
  const [isUploading, setIsUploading] = useState(false)
  const { offline } = useOffline()
  const [uploads, setUploads] = useState([])
  const [uploading, setUploading] = useState([])

  useEffect(() => {
    setUploads(responseUploads ? [...responseUploads] : [])
  }, [responseUploads])

  const handleChange = (event) => {
    clearTimeout(debounceRemove)
    onChange && onChange(event, uploads)
  }

  const handleEdit = (event) => {
    onEdit && onEdit(event)
  }

  const handleBeforeUpload = (items) => {
    setIsUploading(true)
    setUploading(() => items)
  }
  const handleUploadProgress = (items) => {
    setUploading(() => items)
  }
  const handleItemUploaded = (item) => {
    setUploads((state) => [...state, item])
    setUploading([...uploading.filter((upload) => toId(upload) !== toId(item))])
  }
  const handleRemoveUpload = (id) => {
    clearTimeout(debounceRemove)
    const removing = uploads.find((upload) => toId(upload) === id)
    const newUploads = uploads.filter((upload) => toId(upload) !== id)
    setUploads([...newUploads])
    setUploading([...uploading.filter((upload) => toId(upload) !== id)])
    if (!removing.__upload && onRemove) {
      debounceRemove = setTimeout(() => {
        onRemove(newUploads)
      }, debounceRemoveMs)
    }
  }
  const handleNotUploading = () => {
    setIsUploading(false)
  }

  const hasUploads = Boolean(uploads.length || uploading.length)

  return (
    <Collapse in={expand}>
      <Divider className={classes.divider} />
      <Box py={1} px={2}>
        {hasUploads && (
          <Box mb={complete ? 0 : 1}>
            <UploadingImagesList
              uploaded={uploads}
              uploading={uploading}
              onRemoveUpload={complete ? null : handleRemoveUpload}
            />
          </Box>
        )}
        <Collapse in={!complete}>
          <Uploader
            variant="button"
            buttonText={
              <RowBox alignItems="center" justifyItems="center">
                <Icon name="photo" />
                <Box ml={1}>Add photo</Box>
              </RowBox>
            }
            buttonProps={{
              variant: "contained",
              fullWidth: true,
              className: classes.button,
            }}
            documents={false}
            onBeforeUpload={handleBeforeUpload}
            onProgress={handleUploadProgress}
            onItemUploaded={handleItemUploaded}
            onAfterUpload={handleNotUploading}
            onError={handleNotUploading}
            disabled={disabled || offline}
          />
        </Collapse>
      </Box>
      <Collapse in={hasUploads}>
        <Divider className={classes.divider} />

        <RowBox py={1} px={2} className={classes.promptArea}>
          <Box>
            {isUploading && <strong>Uploading...</strong>}
            {!isUploading && !complete && (
              <strong>
                Submit {uploads.length} photo{uploads.length > 1 ? "s" : ""}?
              </strong>
            )}
            {!isUploading && complete && (
              <strong>
                {uploads.length} photo{uploads.length > 1 ? "s" : ""} uploaded
              </strong>
            )}
          </Box>
          <Box onClick={preventDefault} ml="auto">
            {isUploading && (
              <RowBox alignItems="center" mr={1}>
                <CircularProgress size={24} />
              </RowBox>
            )}
            {!isUploading && !complete && (
              <IconButton
                onClick={handleChange}
                className={classes.incompletedButton}
                data-cy={`ProcessStep-field-${PHOTOS}-complete`}
                disabled={disabled}
              >
                <DoneIcon />
              </IconButton>
            )}
            {!isUploading && complete && (
              <IconButton
                onClick={handleEdit}
                className={classes.completedButton}
                data-cy={`ProcessStep-field-${PHOTOS}-uncomplete`}
              >
                <EditIcon />
              </IconButton>
            )}
          </Box>
        </RowBox>
      </Collapse>
    </Collapse>
  )
}

export { AddPhotoStep }
